import React from 'react'

import Header from '../../common/components/Header'
import OverlayList from './OverlayList'

const OverlayPanel = () => {
  return (
    <>
      <Header>Overlays</Header>
      <OverlayList />
    </>
  )
}

export default OverlayPanel
